export default "__VITE_ASSET__ae69d538__"